var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdvancedRuns(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#232323",
    d: "M22 0l22 22-22 22L0 22z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdvancedRuns);
var MemoForwardRef = /*#__PURE__*/React.memo(ForwardRef);
export default "data:image/svg+xml,%3csvg viewBox='0 0 44 44' fill='none' xmlns='http://www.w3.org/2000/svg'%3e %3crect x='22' width='31.1127' height='31.1127' transform='rotate(45 22 0)' fill='%23232323'/%3e %3c/svg%3e";
export { MemoForwardRef as ReactComponent };